export const ticketCategoryName = (ticketCategories, id) => {
    if (id) {
        return ticketCategories.find((x) => x.id === id)?.ticketCategoryName;
    }

    return null;
};
